import { Button } from '@/components/ui/button';
import { toast } from '@/components/ui/hooks/use-toast';
import { refreshSchoolsData } from '@/lib/api-calls';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export const RefreshSchoolsData = () => {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: refreshSchoolsData,
  });

  const handleRefreshSchoolsData = async () => {
    try {
      const response = await mutateAsync();

      if (response.ok) {
        toast({
          title: response.message,
        });
        await queryClient.invalidateQueries({ queryKey: ['SCHOOLS'] });
      } else {
        toast({
          title: 'Failed to refresh schools data',
          description: response.message,
          variant: 'destructive',
        });
      }
    } catch (error) {
      toast({
        title: 'Failed to refresh schools data',
        description: error instanceof Error ? error.message : undefined,
        variant: 'destructive',
      });
    }
  };

  return (
    <Button variant="secondary" onClick={handleRefreshSchoolsData} disabled={isPending} loading={isPending}>
      {isPending ? 'Refreshing...' : 'Refresh data'}
    </Button>
  );
};
